(() => {
  if (window.themeStickySections) return;
  window.themeStickySections = true;
  const stickySections = () => [...document.querySelectorAll('.shopify-section')].filter((section) => section.querySelector(':scope > [data-theme-sticky]') || section.classList.contains('shopify-section-header-sticky'));
  const update = () => {
    let offset = 0;
    for (const section of stickySections()) {
      section.style.setProperty('--theme-sticky-top', `${offset}px`);
      if (!section.classList.contains('shopify-section-header-hidden')) offset += section.offsetHeight;
    }
  };
  const resize = new ResizeObserver(update);
  const classes = new MutationObserver(update);
  const observe = () => {
    resize.disconnect();
    classes.disconnect();
    for (const section of stickySections()) resize.observe(section);
    const header = document.querySelector('.section-header');
    if (header) classes.observe(header, { attributes: true, attributeFilter: ['class'] });
    update();
  };
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(observe));
  observe();
})();
